import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
export function WhatsAppButton() {
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hola! Quiero consultar sobre los productos y servicios de La Victoria II.');
    window.open(`https://wa.me/5492665013601?text=${message}`, '_blank');
  };
  return <motion.button initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} transition={{
    delay: 1,
    type: 'spring'
  }} onClick={handleWhatsApp} className="fixed bottom-6 right-6 z-50 bg-green-500 text-white p-4 rounded-full shadow-2xl hover:bg-green-600 transition-colors group" aria-label="Contactar por WhatsApp" data-id="element-186">
      <motion.div animate={{
      scale: [1, 1.2, 1]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} className="absolute inset-0 bg-green-500 rounded-full opacity-30" data-id="element-187" />
      <MessageCircleIcon size={28} className="relative z-10" data-id="element-188" />
    </motion.button>;
}